<script setup lang="ts">
import { Sun, Moon } from 'lucide-vue-next'
import { useThemeStore, type Theme } from '../stores/theme'

const themeStore = useThemeStore()

const themes: { value: Theme; icon: typeof Sun; label: string }[] = [
  { value: 'light', icon: Sun, label: 'Light' },
  { value: 'dark', icon: Moon, label: 'Dark' }
]
</script>

<template>
  <div class="flex items-center gap-1 p-1 rounded-lg bg-gray-100 dark:bg-dark-elevated">
    <button
      v-for="t in themes"
      :key="t.value"
      @click="themeStore.setTheme(t.value)"
      class="p-1.5 rounded-md transition-all"
      :class="[
        themeStore.theme === t.value
          ? 'bg-white dark:bg-dark-surface text-gray-900 dark:text-white shadow-sm'
          : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200'
      ]"
      :title="t.label"
    >
      <component :is="t.icon" class="w-4 h-4" />
    </button>
  </div>
</template>
